import { useState } from 'react';

type UseFormsInput = {
  fetchUrl: string;
  csrfToken?: string | null;
  onSuccess?: (response?: any) => void;
  beforeSubmit?: (values: any) => Promise<void>;
};

type UseForms = {
  loading: boolean;
  successfullySent: boolean;
  error: boolean;
  formSubmit: (values: any) => Promise<void>;
  errorMessage: string;
  errorMessageArr: string[];
};

function useForms({ fetchUrl, csrfToken, onSuccess, beforeSubmit }: UseFormsInput): UseForms {
  const [loading, setLoading] = useState(false);
  const [successfullySent, setSuccessfully] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessageArr, setErrorMessageArr] = useState<string[]>([]);

  const handleError = () => {
    setError(true);
    setLoading(false);
    setSuccessfully(false);
  };

  const formSubmit = async (values: any) => {
    setLoading(true);

    let body = {
      ...values,
      url: `https://${window.location.hostname}${window.location.pathname ?? ''}${window.location.search ?? ''}`,
    };

    if (beforeSubmit) {
      body = await beforeSubmit(body);
    }

    const headers: HeadersInit = new Headers();
    headers.set('Content-Type', 'application/json');

    if (csrfToken) {
      headers.set('X-CSRF-Token', csrfToken);
      body.csrf_token = csrfToken;
    }

    try {
      const res = await fetch(fetchUrl, {
        body: JSON.stringify(body),
        headers,
        method: 'POST',
      });

      const result: any = await res.json();

      if (result?.success || result?.status?.success) {
        setLoading(false);
        setSuccessfully(true);
        setErrorMessage('');
        setErrorMessageArr([]);
        if (onSuccess) onSuccess(result);
      } else {
        const errorMsg = result?.error?.error_message || result?.message;
        const errorsFlat = Object.values(result?.errors || []).flat();
        const errorMsgArr = errorsFlat.filter((err) => typeof err === 'string') as string[];
        setErrorMessageArr(errorMsgArr);
        setErrorMessage(errorMsg);
        handleError();
      }
    } catch (responseError: any) {
      // eslint-disable-next-line no-console
      if (responseError) {
        setErrorMessage(responseError.message);
        setErrorMessageArr([responseError.message]);
        handleError();
      }
    }
  };

  return {
    loading,
    successfullySent,
    error,
    formSubmit,
    errorMessage,
    errorMessageArr,
  };
}

export default useForms;
